const protocol = window.location.protocol // sera 'http:' ou 'https:'
const websocketProtocol = protocol === 'https:' ? 'wss:' : 'ws:'

const PAGE_QRCODE_WIDTH = 1240
const PAGE_QRCODE_HEIGHT = 1754

const config = {
  URL_API_BACKEND: `${protocol}//${process.env.REACT_APP_API_BASE_URL}`,
  URL_WEBSOCKET_BACKEND: `${websocketProtocol}//${process.env.REACT_APP_API_BASE_URL}`,
  PAGE_QRCODE_WIDTH,
  PAGE_QRCODE_HEIGHT,

  URL_IMG_METRO: `${protocol}//${process.env.REACT_APP_API_BASE_URL}/static/img/metro_black_on_whiteback.svg`,
  URL_IMG_VILLE: `${protocol}//${process.env.REACT_APP_API_BASE_URL}/static/img/ville_black_on_whiteback.svg`,
  URL_IMG_METRO_WHITE: `${protocol}//${process.env.REACT_APP_API_BASE_URL}/static/img/metro_white_on_blackback.svg`,
  URL_IMG_VILLE_WHITE: `${protocol}//${process.env.REACT_APP_API_BASE_URL}/static/img/ville_white_on_whiteback.svg`,
}

console.log('Protocol:', protocol)
console.log('WebSocket Protocol:', websocketProtocol)
console.log('URL API BACKEND:', config.URL_API_BACKEND)
console.log('URL WEBSOCKET BACKEND:', config.URL_WEBSOCKET_BACKEND)

export default config
